module.exports = __webpack_public_path__ + "static/media/retoklegs.0032aa7b.jpg";